import type { LucideIcon, LucideProps } from 'lucide-react';

export interface IconProps extends Omit<LucideProps, 'ref'> {
  icon: LucideIcon;
  /** 16 → stroke 1.75; 20–24 → stroke 1.5 (handoff rule). */
  size?: 16 | 18 | 20 | 24;
}

/** Lucide outline icons in currentColor with the stroke widths of the handoff. */
export function Icon({ icon: Glyph, size = 20, strokeWidth, ...rest }: IconProps) {
  const stroke = strokeWidth ?? (size <= 16 ? 1.75 : 1.5);
  return <Glyph size={size} strokeWidth={stroke} aria-hidden="true" focusable="false" {...rest} />;
}
